export default "__VITE_ASSET__D7F7Yu9e__"